export const contactData = {
  institutionName: "UMED Mental Hospital, Deaddiction and Psychiatric Rehabilitation Centre",
  tagline: "A Safe Space for Healing, Recovery & New Beginnings",
  
  // Primary Rehab Centre Address (Hospital Campus)
  address: {
    line1: "Shri Colony, Sangli - Miraj Rd, behind Bhokare College",
    line2: "Miraj, Samastanagar",
    city: "Sangli Miraj Kupwad",
    state: "Maharashtra",
    pincode: "416410",
    country: "India",
    fullAddress: "Shri Colony, Sangli - Miraj Rd, behind Bhokare College, Miraj, Samastanagar, Sangli Miraj Kupwad, Maharashtra 416410"
  },

  // City OPD Clinic Address
  clinicAddress: {
    line1: "Basement, Namokar Heights, Near Hotel Ayodhya",
    line2: "Vantmure Corner, Sangli - Miraj Road",
    city: "Miraj",
    state: "Maharashtra",
    fullAddress: "Basement, Namokar Heights, Near Hotel Ayodhya, Vantmure Corner, Sangli - Miraj Road, Miraj"
  },

  phones: [
    { label: "Admissions & 24/7 Helpline", number: "+91 9226999705", raw: "+919226999705" },
    { label: "Clinic Contact", number: "+91 8600511455", raw: "+918600511455" }
  ],

  whatsapp: {
    display: "+91 8600511455",
    link: "https://wa.me/918600511455?text=Hello%20UMED%20Team%2C%20I%20would%20like%20to%20inquire%20about%20your%20services."
  },

  socialLinks: {
    facebook: "https://www.facebook.com/share/1BtiBdnJZp/",
    instagram: "https://www.instagram.com/dr.sanadpawar?utm_source=qr&igsh=MW9namdwM2k1d3IyNQ=="
  },

  email: "contact@umedrehabilitation.com",
  admissionsEmail: "pawarsanad.sp@gmail.com",

  // Rehabilitation Centre timings (24/7)
  timings: {
    schedule: "Open 24 Hours / 7 Days a Week (All Days)",
    days: [
      { day: "Sunday", hours: "Open 24 hours" },
      { day: "Monday", hours: "Open 24 hours" },
      { day: "Tuesday", hours: "Open 24 hours" },
      { day: "Wednesday", hours: "Open 24 hours" },
      { day: "Thursday", hours: "Open 24 hours" },
      { day: "Friday", hours: "Open 24 hours" },
      { day: "Saturday", hours: "Open 24 hours" }
    ],
    emergency: "24 Hours / 7 Days a Week (Always Open)",
    consultations: "Open 24 Hours (Monday – Sunday)",
    visitingHours: "Open 24 Hours / 7 Days a Week"
  },

  // City OPD Clinic timings
  clinicTimings: {
    schedule: "Monday To Friday 12:00 PM to 7:00 PM | Saturday & Sunday Closed",
    days: [
      { day: "Monday", hours: "12:00 PM – 7:00 PM" },
      { day: "Tuesday", hours: "12:00 PM – 7:00 PM" },
      { day: "Wednesday", hours: "12:00 PM – 7:00 PM" },
      { day: "Thursday", hours: "12:00 PM – 7:00 PM" },
      { day: "Friday", hours: "12:00 PM – 7:00 PM" },
      { day: "Saturday", hours: "Closed" },
      { day: "Sunday", hours: "Closed" }
    ]
  },

  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d913.3893047874234!2d74.62177861307714!3d16.833596577791194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc1234fc7f2b215%3A0xada8d59979d81384!2sUmed%20Mental%20Hospital%2C%20Deaddiction%20and%20Psychiatric%20Rehabilitation%20Centre!5e0!3m2!1sen!2sin!4v1786860863275!5m2!1sen!2sin",

  clinicMapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3818.870421478628!2d74.6404244!3d16.832783199999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc1239f5576701d%3A0x5e4facf9980f8cb3!2sUmed%20Mental%20Health%20Clinic%20And%20Counselling%20Centre!5e0!3m2!1sen!2sin!4v1787136480930!5m2!1sen!2sin",

  locations: [
    {
      id: "rehab",
      name: "UMED Rehabilitation Centre (Hospital Campus)",
      badge: "24/7 Hospital & Inpatient Rehab",
      address: "Shri Colony, Sangli - Miraj Rd, behind Bhokare College, Miraj, Samastanagar, Sangli Miraj Kupwad, Maharashtra 416410",
      phone: "+91 9226999705",
      rawPhone: "+919226999705",
      hours: "Open 24 Hours / 7 Days (24/7 All Days)",
      mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d913.3893047874234!2d74.62177861307714!3d16.833596577791194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc1234fc7f2b215%3A0xada8d59979d81384!2sUmed%20Mental%20Hospital%2C%20Deaddiction%20and%20Psychiatric%20Rehabilitation%20Centre!5e0!3m2!1sen!2sin!4v1786860863275!5m2!1sen!2sin"
    },
    {
      id: "clinic",
      name: "UMED Mental Health Clinic & Counselling Centre",
      badge: "OPD & Counselling Centre",
      address: "Basement, Namokar Heights, Near Hotel Ayodhya, Vantmure Corner, Sangli - Miraj Road, Miraj",
      phone: "+91 8600511455",
      rawPhone: "+918600511455",
      hours: "Monday to Friday: 12:00 PM – 7:00 PM (Saturday & Sunday Closed)",
      mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3818.870421478628!2d74.6404244!3d16.832783199999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc1239f5576701d%3A0x5e4facf9980f8cb3!2sUmed%20Mental%20Health%20Clinic%20And%20Counselling%20Centre!5e0!3m2!1sen!2sin!4v1787136480930!5m2!1sen!2sin"
    }
  ]
};
